var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartperson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 64,
    viewBox: "0 0 62 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.642,
    y1: 0.015,
    x2: 0.301,
    y2: 0.805,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#cf003c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expertise_and_Experience",
    "data-name": "Expertise and Experience",
    transform: "translate(-215.854 -2128.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M794.78,735.359c8.272,8.111,10.911,17.959,8.331,28.879-3.394,14.361-12.366,23.806-26.946,27.138C756.657,795.833,740.4,779.957,742.2,761c1.4-14.762,9.115-25.286,22.948-30.641C775.732,726.261,785.832,727.761,794.78,735.359Z",
    transform: "translate(-526.207 1400.468)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(228.604 2142.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9784",
    "data-name": "Path 9784",
    d: "M27.5,11.245a.715.715,0,0,1-.475-.119.574.574,0,0,1,0-.832l3.566-3.566a.588.588,0,0,1,.832.832l-3.566,3.566c0,.119-.238.119-.357.119ZM12.641,25.863H12.4c-.357-.119-3.8-1.783-3.8-4.041v-2.5a.594.594,0,1,1,1.189,0v2.5c0,1.189,1.9,2.377,2.852,2.852.951-.475,2.852-1.664,2.852-2.852v-2.5a.594.594,0,1,1,1.189,0v2.5c0,2.258-3.447,3.8-3.8,4.041Z",
    transform: "translate(1.433 0.749)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9785",
    "data-name": "Path 9785",
    d: "M13.131,20.008A7.152,7.152,0,0,1,6,12.877V11.094a.561.561,0,0,1,.594-.594.561.561,0,0,1,.594.594v1.783a5.943,5.943,0,1,0,11.885,0V11.094a.594.594,0,0,1,1.189,0v1.783A7.152,7.152,0,0,1,13.131,20.008Z",
    transform: "translate(0.943 1.494)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9786",
    "data-name": "Path 9786",
    d: "M19.871,12.945h-.357a.561.561,0,0,1-.594-.594.544.544,0,0,1,.475-.594l1.07-2.971a1.562,1.562,0,0,0-.357-1.426,1.857,1.857,0,0,0-1.426-.713.561.561,0,0,1-.594-.594,2.8,2.8,0,0,0-.832-1.9,2.136,2.136,0,0,0-1.9-.475L8.223,4.863a2.642,2.642,0,0,0-1.545.951,2.705,2.705,0,0,0-.475,1.9l1.07,4.041a.544.544,0,0,1,.475.594.561.561,0,0,1-.594.594H6.8a.79.79,0,0,1-.594-.475L5.014,7.953a3.268,3.268,0,0,1,.594-2.734A3.37,3.37,0,0,1,7.986,3.793L15.117,2.6a3.537,3.537,0,0,1,4.041,3.09,2.257,2.257,0,0,1,1.783.951,2.778,2.778,0,0,1,.594,2.5l-1.189,3.328A.511.511,0,0,1,19.871,12.945Z",
    transform: "translate(0.74)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9787",
    "data-name": "Path 9787",
    d: "M20.491,12.048h-.357a1.7,1.7,0,0,1-1.664-1.664V8.6a10.126,10.126,0,0,1-7.606,1.664l-.951-.238a.531.531,0,0,0-.357.475,1.7,1.7,0,0,1-1.664,1.664H7.656a.594.594,0,1,1,0-1.189h.357a.511.511,0,0,0,.475-.475,1.7,1.7,0,0,1,1.664-1.664l1.189.238a8.58,8.58,0,0,0,6.774-1.545A1.406,1.406,0,0,1,19.3,7.412a1.212,1.212,0,0,1,.594.951v2.02a.511.511,0,0,0,.475.475h.357a.561.561,0,0,1,.594.594c0,.357-.475.594-.832.594Zm6.061,21.631H1.594A.561.561,0,0,1,1,33.084v-4.4a5.761,5.761,0,0,1,3.8-5.348l5.586-1.9a.564.564,0,0,1,.357,1.07l-5.586,1.9a4.624,4.624,0,0,0-2.971,4.279v3.8h23.77v-3.8a4.355,4.355,0,0,0-2.971-4.16l-5.586-1.9a.564.564,0,1,1,.357-1.07l5.586,1.9a5.534,5.534,0,0,1,3.8,5.348v4.279A.561.561,0,0,1,26.553,33.678Z",
    transform: "translate(0 0.897)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9788",
    "data-name": "Path 9788",
    d: "M26.553,34.213H20.61a.561.561,0,0,1-.594-.594v-.951a6.563,6.563,0,0,1,5.824-6.537.908.908,0,0,1,.594.238,6.1,6.1,0,0,1,.832,2.852v4.4A.753.753,0,0,1,26.553,34.213ZM21.2,33.024h4.754v-3.8a3.763,3.763,0,0,0-.475-1.9A5.375,5.375,0,0,0,21.2,32.668v.357ZM7.537,34.213H1.594A.561.561,0,0,1,1,33.618v-4.4a4.987,4.987,0,0,1,.832-2.852.434.434,0,0,1,.594-.238,6.559,6.559,0,0,1,5.7,6.537v.951A.561.561,0,0,1,7.537,34.213ZM2.189,33.024H6.943v-.357a5.579,5.579,0,0,0-4.4-5.348,5.383,5.383,0,0,0-.357,1.9v3.8ZM7.537,15.2H6.348a1.828,1.828,0,0,1-1.783-1.783V12.225a1.828,1.828,0,0,1,1.783-1.783h.594a.594.594,0,1,1,0,1.189H6.348a.561.561,0,0,0-.594.594v1.189a.561.561,0,0,0,.594.594h.594V12.82a.594.594,0,0,1,1.189,0V14.6A.561.561,0,0,1,7.537,15.2Zm14.262,0H20.61a.561.561,0,0,1-.594-.594V12.82a.594.594,0,0,1,1.189,0v1.189H21.8a.561.561,0,0,0,.594-.594V12.225a.561.561,0,0,0-.594-.594H21.2a.594.594,0,1,1,0-1.189H21.8a1.828,1.828,0,0,1,1.783,1.783v1.189A1.828,1.828,0,0,1,21.8,15.2Zm5.943,1.189c-.119,0-.238,0-.238-.119-.238-.119-.357-.238-.357-.475V14.008h-.594a1.828,1.828,0,0,1-1.783-1.783V6.283A1.828,1.828,0,0,1,26.553,4.5h8.32a1.828,1.828,0,0,1,1.783,1.783v5.943a1.828,1.828,0,0,1-1.783,1.783H31.545L28.1,16.266a.437.437,0,0,1-.357.119Zm-1.189-10.7a.561.561,0,0,0-.594.594v5.943a.561.561,0,0,0,.594.594h1.189a.561.561,0,0,1,.594.594v1.307l2.615-1.783a.437.437,0,0,1,.357-.119h3.566a.561.561,0,0,0,.594-.594V6.283a.561.561,0,0,0-.594-.594Z",
    transform: "translate(0 0.363)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 0.951,
    cy: 0.951,
    r: 0.951,
    transform: "translate(28.336 7.24)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 0.951,
    cy: 0.951,
    r: 0.951,
    transform: "translate(31.188 10.211)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9789",
    "data-name": "Path 9789",
    d: "M11.5,22.3h1.189v7.963H11.5Z",
    transform: "translate(1.979 3.718)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartperson);
export default __webpack_public_path__ + "static/media/startperson.ad4dceb8ca434dcfba7bb76218df7d94.svg";
export { ForwardRef as ReactComponent };